import React from 'react'
import PropTypes from 'prop-types'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const DonationSection = ({
  barCode,
  accountType,
  creditValue,
  donationPointsValue
}) => (
  <div className='col-9  txt-left  justify-content-center align-self-center'>
    <p className='txt-body-sm txt-font-body color-ui-2'>
      Transação: <strong>Doação de reales</strong>
    </p>
    <p className='txt-body-sm  txt-font-body color-ui-2'>
      Valor:{' '}
      <strong>
        <CatalogCurrencyLabel value={donationPointsValue} /> = R$ {creditValue}
      </strong>
    </p>
  </div>
)

DonationSection.propTypes = {
  barCode: PropTypes.string,
  accountType: PropTypes.string,
  creditValue: PropTypes.number,
  donationPointsValue: PropTypes.any
}

export default DonationSection



// WEBPACK FOOTER //
// ./src/features/Donation/Sidebar/DonationSection.js